<template>
  <div v-html="$vnode.data.html[0]"></div>
</template>
<script>
export default {
  name: "html-renderer",
};
</script>
